import { getToken, setToken } from '@/utils/index'
import { toLogin } from '@/api/authority'

const state = {
  token: getToken(),
  name: '',
  uuid: '',
  roleName: '',
  roleUuid: '',
  access: []
}

const mutations = {
  SET_TOKEN: (state, data) => {
    state.token = data
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_UUID: (state, uuid) => {
    state.uuid = uuid
  },
  SET_ROLE_NAME: (state, roleName) => {
    state.roleName = roleName
  },
  SET_ROLE_UUID: (state, roleUuid) => {
    state.roleUuid = roleUuid
  },
  SET_ACCESS: (state, val) => {
    state.access.push(val)
  },
  CLEAR_ACCESS: (state, val) => {
    state.access = val
  },
}

const actions = {
  login({ commit }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      toLogin({ account: account, password: password }).then(res => {
        commit('SET_NAME', res.data.name)
        commit('SET_TOKEN', res.data.token)
        commit('SET_UUID', res.data.uuid)
        commit('SET_ROLE_NAME', res.data.roleName)
        commit('SET_ROLE_UUID', res.data.roleUuid)
        setToken(res.data.token)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addBtnAccess({ commit, state }, item) {
    commit('SET_ACCESS', item.subName)
    // let res = ''
    // res = state.access.filter(label => label.uuid === item.uuid)
    // res.length ? '' : commit('SET_ACCESS', item)
  },
  clearAccess({ commit, state }, val) {
    commit('CLEAR_ACCESS', val)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
